import '../Home_css/Footer.css';
import React from 'react';
import Footerimg1 from '../../Assets/icons/Logomark_icon.webp';
import { Container, Row, Col } from 'react-bootstrap';
import footerimg2 from "../../Assets/icons/BeEnlightened_Slogan.webp";
import { Link } from 'react-router-dom';
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">


          <Row className="justify-content-center text-center">
            <Col xs={12} sm={3} className="footer-left">
              <a href="/#home">
                <img src={Footerimg1} alt="Dahlia" className="footer-home" />
              </a>
            </Col>
            <Col xs={12} sm={8} className="footer-right">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/accessibility">Accessibility</Link>
            </Col>
          </Row>

          <Row>
            <Col>
              <p>
                The statements made regarding these products have not been evaluated by the Food and Drug Administration.
                The efficacy of these products has not been confirmed by FDA-approved research. These products are not intended to diagnose,
                treat, cure or prevent any disease. All information presented here is not meant as a substitute for or alternative to information from healthcare practitioners.
                Please consult your healthcare professional about potential interactions or other possible complications before using any product. The statements made on this website
                are for educational purposes only and are not meant to replace the advice of your physician or healthcare provider. Furthermore, none of the statements on this website
                should be construed as dispensing medical advice, making claims regarding the cure of diseases, nor can these products prevent disease.
              </p>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <p>Copyright © 2020-{currentYear}, Dahlia Health, LLC. All Rights Reserved. No reproduction is allowed without written permission.</p>
              <img className='footer-logo' src={footerimg2} alt="Footer Logo" />
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
